import holidayComponent from './holiday.component';
import holidayModalFactory from './modal/modal.factory'

let holdidayModule = angular.module('holiday', [])

  .config(($stateProvider, $urlRouterProvider) => {
    "ngInject";
  })

  .component('holiday', holidayComponent)

  .service('HolidayModal', holidayModalFactory)

  .name;

export default holdidayModule;


// WEBPACK FOOTER //
// ./client/app/components/holiday/index.js